var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#CCEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0846 27.7507L41.168 23.6673M43.5013 21.334L41.168 23.6673L43.5013 21.334ZM32.2896 32.5457C32.892 33.14 33.3709 33.8477 33.6987 34.6279C34.0265 35.4081 34.1967 36.2455 34.1995 37.0917C34.2023 37.938 34.0377 38.7764 33.7152 39.5588C33.3927 40.3412 32.9185 41.0521 32.3201 41.6505C31.7217 42.2489 31.0109 42.723 30.2285 43.0455C29.4461 43.3681 28.6076 43.5327 27.7614 43.5298C26.9151 43.527 26.0778 43.3568 25.2976 43.029C24.5173 42.7013 23.8097 42.2224 23.2153 41.62C22.0464 40.4098 21.3997 38.7889 21.4143 37.1065C21.4289 35.4241 22.1038 33.8147 23.2935 32.625C24.4832 31.4353 26.0925 30.7604 27.775 30.7458C29.4574 30.7312 31.0783 31.378 32.2885 32.5468L32.2896 32.5457ZM32.2896 32.5457L37.0846 27.7507L32.2896 32.5457ZM37.0846 27.7507L40.5846 31.2507L44.668 27.1673L41.168 23.6673L37.0846 27.7507Z",
    stroke: "#3DABF5",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#E3F4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ff305ed8d332758f2d39e567a6037478.svg";
export { ForwardRef as ReactComponent };